var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Container, Typography, Paper, Grid, Button, CircularProgress, Alert, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { nasdaq100XGBoostApi } from '../services/api';
import { format } from 'date-fns';
var Nasdaq100XGBoost = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(null), predictions = _c[0], setPredictions = _c[1];
    var _d = useState(null), requestId = _d[0], setRequestId = _d[1];
    var currentUser = useAuth().currentUser;
    var navigate = useNavigate();
    useEffect(function () {
        if (!currentUser) {
            navigate('/login');
        }
    }, [currentUser, navigate]);
    useEffect(function () {
        var intervalId;
        var checkPredictionStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!requestId)
                            return [2 /*return*/];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, nasdaq100XGBoostApi.getPredictionStatus(requestId)];
                    case 2:
                        response = _a.sent();
                        if (response.status === 'completed' && response.result) {
                            setPredictions(response.result);
                            setLoading(false);
                            setRequestId(null);
                        }
                        else if (response.status === 'error') {
                            setError(response.error || 'An error occurred during prediction');
                            setLoading(false);
                            setRequestId(null);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        setError('Error checking prediction status');
                        setLoading(false);
                        setRequestId(null);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        if (requestId) {
            intervalId = setInterval(checkPredictionStatus, 2000);
        }
        return function () {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [requestId]);
    var handlePredict = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    setPredictions(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, nasdaq100XGBoostApi.predict({
                            prediction_date: format(new Date(), 'yyyy-MM-dd'),
                            rebalance_frequency: 'M',
                            top_n: 10,
                            min_history_days: 252,
                        })];
                case 2:
                    response = _a.sent();
                    setRequestId(response.request_id);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _a.sent();
                    setError('Error making prediction');
                    setLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var formatPercentage = function (value) {
        return "".concat((value * 100).toFixed(2), "%");
    };
    var formatCurrency = function (value) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        }).format(value);
    };
    var renderBacktestSummary = function (summary) { return (_jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, children: _jsxs(Typography, { variant: "h6", gutterBottom: true, children: ["Backtest Summary (", summary.start_date, " to ", summary.end_date, ")"] }) }), _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsxs(Paper, { elevation: 2, sx: { p: 2 }, children: [_jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Equal Weight Strategy" }), _jsxs(Typography, { children: ["CAGR: ", formatPercentage(summary.equal_weight.cagr)] }), _jsxs(Typography, { children: ["Max Drawdown: ", formatPercentage(summary.equal_weight.max_drawdown)] }), _jsxs(Typography, { children: ["Sharpe Ratio: ", summary.equal_weight.sharpe_ratio.toFixed(2)] })] }) }), _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsxs(Paper, { elevation: 2, sx: { p: 2 }, children: [_jsx(Typography, { variant: "subtitle1", gutterBottom: true, children: "Prediction Weight Strategy" }), _jsxs(Typography, { children: ["CAGR: ", formatPercentage(summary.prediction_weight.cagr)] }), _jsxs(Typography, { children: ["Max Drawdown: ", formatPercentage(summary.prediction_weight.max_drawdown)] }), _jsxs(Typography, { children: ["Sharpe Ratio: ", summary.prediction_weight.sharpe_ratio.toFixed(2)] })] }) })] })); };
    var renderRecommendations = function (recommendations) { return (_jsx(TableContainer, { component: Paper, children: _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Symbol" }), _jsx(TableCell, { children: "Company" }), _jsx(TableCell, { align: "right", children: "Current Price" }), _jsx(TableCell, { align: "right", children: "Predicted Return" }), _jsx(TableCell, { align: "right", children: "Market Cap" }), _jsx(TableCell, { align: "right", children: "Volume" }), _jsx(TableCell, { align: "right", children: "Volatility" })] }) }), _jsx(TableBody, { children: recommendations.map(function (stock) { return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: stock.symbol }), _jsx(TableCell, { children: _jsx(Tooltip, { title: "Sector: ".concat(stock.sector), children: _jsx("span", { children: stock.company_name }) }) }), _jsx(TableCell, { align: "right", children: formatCurrency(stock.current_price) }), _jsx(TableCell, { align: "right", children: formatPercentage(stock.predicted_return) }), _jsx(TableCell, { align: "right", children: formatCurrency(stock.market_cap) }), _jsx(TableCell, { align: "right", children: stock.volume.toLocaleString() }), _jsx(TableCell, { align: "right", children: formatPercentage(stock.historical_volatility) })] }, stock.symbol)); }) })] }) })); };
    return (_jsxs(Container, { maxWidth: "lg", sx: { mt: 4, mb: 4 }, children: [_jsx(Typography, { variant: "h4", gutterBottom: true, children: "Nasdaq 100 XGBoost Predictions" }), _jsx(Box, { sx: { mb: 4 }, children: _jsx(Button, { variant: "contained", color: "primary", onClick: handlePredict, disabled: loading, children: loading ? (_jsxs(_Fragment, { children: [_jsx(CircularProgress, { size: 24, sx: { mr: 1 } }), "Generating Predictions..."] })) : ('Generate Predictions') }) }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: error })), predictions && (_jsxs(Grid, { container: true, spacing: 3, children: [_jsx(Grid, { item: true, xs: 12, children: renderBacktestSummary(predictions.backtest_summary) }), _jsxs(Grid, { item: true, xs: 12, children: [_jsx(Typography, { variant: "h6", gutterBottom: true, children: "Top Stock Recommendations" }), renderRecommendations(predictions.recommendations)] })] }))] }));
};
export default Nasdaq100XGBoost;
